import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { SubCategoryType } from '~types/categories';
import { apiService } from '~services/ApiService';

export function useGetSubcategories() {
  return useQuery<SubCategoryType[], Error>(
    'allSubCategories', // Query key
    async () => {
      return await apiService.get<SubCategoryType[]>('subcategories');
    },
  );
}
